module.exports = __webpack_public_path__ + "static/media/aboutimg.f580c509.svg";